import { PricingPolicyErrorCodesLookup } from '~/common/helpers';
import { useErrorTranslation } from '~/common/hooks';

export const usePricingPolicyErrorTranslation = () =>
  useErrorTranslation(PricingPolicyErrorCodesLookup);
